import { Spinner, SpinnerSize, TextField, useTheme } from '@fluentui/react';
import React from 'react';
import { useGetCompaniesQuery } from '../../store/Api';

interface ICompanyFilterMenuProps {
    selected?: string;
    onSelect: (companyId?: string) => void;
}

const CompanyFilterMenu: React.FC<ICompanyFilterMenuProps> = (props) => {
    const theme = useTheme();
    const [query, setQuery] = React.useState('');
    const [tempQuery, setTempQuery] = React.useState('');
    const companies = useGetCompaniesQuery({ query: { query } });

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            if (tempQuery !== query) {
                setQuery(tempQuery);
            }
        }, 500);
        return () => clearTimeout(timeout);
    }, [tempQuery, query]);

    return (
        <div style={{ padding: '1em', width: 250 }}>
            <TextField
                placeholder='Search companies...'
                value={tempQuery}
                onChange={(e, newValue) => setTempQuery(newValue ?? '')}
            />
            <div style={{ maxHeight: 300, overflowY: 'auto', marginTop: '0.5em' }}>
                <div
                    style={{ cursor: 'pointer', padding: '0.5em' }}
                    onClick={() => props.onSelect(undefined)}
                >
                    [No Filter]
                </div>
                {companies.isFetching ? (
                    <Spinner size={SpinnerSize.small} />
                ) : (
                    companies.data?.items?.map((company) => (
                        <div
                            key={company.id}
                            style={{
                                cursor: 'pointer',
                                padding: '0.5em',
                                backgroundColor: company.id === props.selected ? theme.palette.themeLighter : undefined,
                            }}
                            onClick={() => props.onSelect(company.id)}
                        >
                            {company.companyName}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default CompanyFilterMenu;
